import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FuseAlertComponent } from '@fuse/components/alert/alert.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'app-alert',
  imports: [FuseAlertComponent, TranslocoPipe, NgClass],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent extends Toast {
  public types = {
    'toast-success': 'success',
    'toast-warning': 'warning',
    'toast-error': 'error',
    'toast-info': 'info',
    basic: 'basic',
    accent: 'accent',
  };
}
